import { forwardRef } from "react";
import type { LinkProps } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
    return <RouterLink {...props} ref={ref} />;
});
Link.displayName = "Link";
